import { IconButton, InputAdornment, TextField } from "@mui/material";
import { ClearIcon, DatePicker } from "@mui/x-date-pickers";
import { Moment } from "moment";

type Props = {
	value: Moment | null;
	onChange: (date: Moment | null) => void;
	canBeNull?: boolean;
};

export const StartFilter = ({ value, onChange }: Props) => {
	return (
		<DatePicker
			label="Start"
			format="MM/DD/YYYY"
			value={value}
			onChange={(newValue) => {
				onChange(newValue);
			}}
			slots={{
				textField: (params) => <TextField {...params} size="small" />,
			}}
			slotProps={{
				textField: {
					inputProps: {
						"data-test-id": "start-date-input",
					},
					sx: {
						backgroundColor: (theme) => theme.palette.background.paper,
					},
				},
			}}
		/>
	);
};

export const EndFilter = ({ value, onChange, canBeNull = false }: Props) => {
	return (
		<DatePicker
			label="End"
			format="MM/DD/YYYY"
			value={value}
			onChange={(newValue) => {
				onChange(newValue);
			}}
			slots={{
				textField: (params) => (
					<TextField
						{...params}
						size="small"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{value && canBeNull && (
										<InputAdornment position="end">
											<IconButton size="small" onClick={() => onChange(null)}>
												<ClearIcon fontSize="small" />
											</IconButton>
										</InputAdornment>
									)}
									{params.InputProps?.endAdornment}
								</>
							),
						}}
					/>
				),
			}}
			slotProps={{
				textField: {
					inputProps: {
						"data-test-id": "end-date-input",
					},
					sx: {
						backgroundColor: (theme) => theme.palette.background.paper,
					},
				},
			}}
		/>
	);
};
